import { Component, OnInit, OnDestroy, AfterViewInit, HostListener } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent  implements AfterViewInit, OnDestroy {
 
   isNavOpen = false;

  // navTog button click → toggle
  toggleNav(): void {
    this.isNavOpen = !this.isNavOpen;
  }

  // Link click pe close
  closeNav(): void {
    this.isNavOpen = false;
  }

  // Nav ke bahar click pe close
  @HostListener('document:click', ['$event'])
  onOutsideClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.unav')) {
      this.isNavOpen = false;
    }
  }
  private scrollListener = () => this.animateBars();
 
  ngAfterViewInit(): void {
    // Page load pe ek baar run karo
    this.animateBars();
    // Scroll pe bhi run karo
    window.addEventListener('scroll', this.scrollListener);
  }
 
  ngOnDestroy(): void {
    // Memory leak se bachne ke liye remove karo
    window.removeEventListener('scroll', this.scrollListener);
  }
 
  animateBars(): void {
    const bars = [
      { id: 'bar1', w: '30%' },
      { id: 'bar2', w: '20%' },
      { id: 'bar3', w: '50%' },
    ];
 
    bars.forEach((b) => {
      const el = document.getElementById(b.id) as HTMLElement;
      if (!el) return;
 
      const alloc = el.closest('.alloc');
      if (!alloc) return;
 
      const rect = alloc.getBoundingClientRect();
      if (rect.top < window.innerHeight - 60 && !el.dataset['done']) {
        el.dataset['done'] = '1';
        el.style.width = b.w;
      }
    });
  }
}
